import React, { useState, forwardRef } from 'react';
import classnames from 'classnames';
import { BiSearchAlt2 } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';

export const SearchInput = forwardRef(
  ({ onChange, onReset, value, className }, ref) => {
    const [focussed, setFocussed] = useState(false);
    return (
      <div
        className={classnames(
          'flex relative items-center justify-center max-w-md w-full mx-auto rounded-lg bg-white border border-white focus-within:border-primary',
          className,
        )}
      >
        <div className="flex flex-1 py-1.5 px-1 h-full b-white">
          <input
            ref={ref}
            aria-label="Search for articles"
            onFocus={() => setFocussed(true)}
            onBlur={() => setFocussed(false)}
            className="
              bg-none
              text-midnight
              outline-none
              focus:outline-none
              text-center
              focus:border-none
              w-full
              flex-1
            "
            type="text"
            value={value}
            onChange={onChange}
          />
          {!value && !focussed && (
            <span
              aria-hidden="true"
              className="absolute left-0 right-0  text-center pointer-events-none"
            >
              <BiSearchAlt2 className="text-black mr-1" />
              <span className="opacity-30">Search for articles</span>
            </span>
          )}
        </div>
        {value && onReset && (
          <div className="mr-2 cursor-pointer">
            <MdClose color="#aaa" onClick={() => onReset()} />
          </div>
        )}
      </div>
    );
  },
);
